export class ImageUrl {
    image: string

    constructor(image: string) {
        this.image = image
        this.ensureHttps()
    }

    ensureHttps() {
        if (this.image.startsWith('http:/')) {
            this.image = this.image.replace(
                /http:\/\/([a-z0-9\-.])+amazon.com/,
                'https://m.media-amazon.com'
            )
        }
    }

    applyTag(tag: string) {
        const splitIndex = this.image.lastIndexOf('.')
        const imagePath = this.image.substring(0, splitIndex)
        const tagToAdd =
            imagePath.charAt(imagePath.length - 1) === '_'
                ? `${tag}_`
                : `._${tag}_`
        this.image = imagePath + tagToAdd + this.image.substring(splitIndex)
    }

    // Remove any previously applied tags except for id tags
    stripTags() {
        // Take any image id tag to save if it exists - these tags start with V or CB
        const id = this.image.match(/_((V|CB)[^_]*)/)

        // Replace all the tags already added
        this.image = this.image.replace(/\._.*?_\./, '.')

        // If the id existed on the original version add it back on
        if (id) {
            this.applyTag(id[1])
        }
        return this
    }

    forceFormat(format: string) {
        this.applyTag(`FM${format}`)
        return this
    }

    scaleHeight(height: number) {
        this.applyTag(`SY${height}`)
        return this
    }

    scaleWidth(width: number) {
        this.applyTag(`SX${width}`)
        return this
    }

    /** Beware this will upscale smaller images potentially resulting in bad image quality */
    upscaleWidth(width: number) {
        this.applyTag(`UX${width}`)
        return this
    }

    /** Beware this will upscale smaller images potentially resulting in bad image quality */
    upscaleHeight(height: number) {
        this.applyTag(`UY${height}`)
        return this
    }

    crop({ width, height, x = 0, y = 0 }: { width: number, height: number, x?: number, y?: number }) {
        this.applyTag(`CR${x},${y},${width},${height}`)
        return this
    }

    setBlur(blurLevel: number) {
        this.applyTag(`BL${blurLevel}`)
        return this
    }

    getImageUrl() {
        return this.image
    }
}
